// extracted by mini-css-extract-plugin
module.exports = {"videoModalRoot":"index-videoModalRoot-3zDGO","videoWrapper":"index-videoWrapper-2DEnT","video":"index-video-j0tDN","closeBtn":"index-closeBtn-3sr5y"};